// Imports
import MicroModal, { MicroModalConfig } from 'micromodal';


/** Wrapper around `MicroModal` that applies defaults */
const modalHelpers = {
	show: (identifier: string, config?: MicroModalConfig) => {
		// Build the final config
		const finalConfig: MicroModalConfig = {
			disableScroll: true,
			awaitCloseAnimation: true,
			...config,
		};
		
		
		// Preserve scrollbar gutter to prevent content shifting
		if (finalConfig.disableScroll && !(window as typeof window & { STORYBOOK?: true }).STORYBOOK) {
			document.documentElement.style.scrollbarGutter = 'stable';
		}
		
		
		// Show the modal
		MicroModal.show(identifier, {
			...finalConfig,
			onClose: (modal) => {
				document.documentElement.style.scrollbarGutter = '';
				config?.onClose?.(modal);
			},
		});
	},
	close: MicroModal.close,
};

export default modalHelpers;
